import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { formatARS } from "@/lib/format";

export default function ProductCard({ product, index = 0 }) {
  const { addItem } = useCart();
  const img = product.images?.[0];
  const off = product.original_price
    ? Math.round((1 - product.price / product.original_price) * 100)
    : 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.1 }}
      transition={{ duration: 0.5, delay: Math.min(index * 0.05, 0.3), ease: [0.16, 1, 0.3, 1] }}
      className="group relative flex flex-col border border-white/10 bg-panel transition-colors hover:border-volt/50"
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/producto/${product.id}`} data-testid={`product-link-${product.id}`} className="relative block aspect-square overflow-hidden bg-panel-2">
        {img && (
          <img
            src={img}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
        )}
        {product.badge && (
          <span className="absolute left-3 top-3 bg-volt px-2.5 py-1 font-mono text-[10px] font-bold uppercase tracking-widest text-black">
            {product.badge}
          </span>
        )}
        {off > 0 && (
          <span className="absolute right-3 top-3 border border-volt/40 bg-black/80 px-2 py-1 font-mono text-[10px] font-bold text-volt">
            -{off}%
          </span>
        )}
      </Link>
      <div className="flex flex-1 flex-col gap-1 p-4">
        <p className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">
          {product.brand || product.category}
        </p>
        <Link
          to={`/producto/${product.id}`}
          className="font-display text-lg font-bold uppercase leading-tight text-white transition-colors hover:text-volt"
        >
          {product.name}
        </Link>
        <div className="mt-auto flex items-end justify-between gap-2 pt-3">
          <div>
            <p className="font-mono text-base font-bold text-white">{formatARS(product.price)}</p>
            {product.original_price && (
              <p className="font-mono text-xs text-zinc-500 line-through">{formatARS(product.original_price)}</p>
            )}
          </div>
          <button
            data-testid={`add-to-cart-button-${product.id}`}
            onClick={() => addItem(product)}
            aria-label={`Agregar ${product.name} al carrito`}
            className="flex h-10 w-10 items-center justify-center bg-volt text-black transition-colors hover:bg-volt-dim"
          >
            <Plus className="h-5 w-5" strokeWidth={2.5} />
          </button>
        </div>
      </div>
    </motion.div>
  );
}
